import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";
import { makeAdditionalSearchableFeature } from "@navigationRouting/utils";

import type { I18nT } from "@lib/dashboardI18n";

const CustomObjectsNROScene = lazy(() =>
  import("@scenes/CustomObjects").then((module) => ({
    default: module.CustomObjectsNROScene,
  }))
);

export const customObjectsListNRO: NavigationRoutingObject = {
  Component: CustomObjectsNROScene,
  componentFeatureFlippers: ["accounts_nro_component", "b2b_ea"],
  noKnockoutFallback: true,
  section: "data-settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("accounts-nro-heading", "Accounts"),
  pageNameForTracking: () => "Accounts",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("accounts-nro-description", "Store business records and connect them to your users"),
  icon: "nav-system-accounts",
  tag: "early-access",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("accounts_nro_component") && featureOn("b2b_ea");
  },
  additionalSearchTerms: () => [],
  // The list route carries a :typeName segment beyond :appGroupId, so it needs an explicit searchable
  // feature (with the concrete account type_name) to remain in navigation search / recently visited —
  // otherwise extractVisitInfo filters it out. The nav entry is account-specific, like the side-nav.
  additionalSearchableFeatures: (t: I18nT<"dashboard-navigation">) => ({
    accounts: makeAdditionalSearchableFeature({
      heading: t("accounts-nro-heading", "Accounts"),
      pathname: "/dashboard/data_objects/:typeName/:appGroupId",
      query: { typeName: "account" },
      description: t("accounts-nro-description", "Store business records and connect them to your users"),
      additionalSearchTerms: [],
    }),
  }),
  defaultRoute: "/dashboard/accounts/:appGroupId",
};
